import React from 'react';

/** Women's goal circle (circle with a short goal-line dash), drawn like the capture field. */
const WomensFieldMark: React.FC<{ className?: string }> = ({ className = 'w-12 h-12' }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden>
    <g fill="none" stroke="rgb(var(--sd-line-strong))" strokeWidth="2" strokeLinecap="round">
      <circle cx="24" cy="24" r="22" />
      <line x1="17" y1="24" x2="31" y2="24" />
    </g>
  </svg>
);

export default WomensFieldMark;
